import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import LoadingDialog from '../../../../components/loadingdialog/components/loadingdialog';
import GeneralChip from '../../../../components/generalchip/generalchip';
import useReviewSearch from '../../../../modules/hooks/reviewsearch/hook';
import { CRITERIA_ITEM_TYPES } from '../../../../modules/hooks/reviewsearch/hook';
import { INPUT_TYPES } from '../../../../modules/hooks/auditsearch/hook';
import SearchResults from './searchresults';

const useStyles = makeStyles(theme => ({
  root: {
    maxHeight:'100%'
  },
  leftcol: {
    width:'35%',
    display:'inline-block'
  },
  rightcol: {
    width:'65%',
    display:'inline-block',
    verticalAlign:'top',
    maxHeight: '82vh',
    overflowY: 'auto'
  },
  filteritem: {
    marginBottom:'4px'
  },
  dropdownwithchips: {
    display: 'inline-block',
    width: '180px',
    marginBottom:'4px'
  },
  chipswithdropdown: {
    display: 'inline-block',
    verticalAlign: 'top',
    maxWidth: '400px',
    marginBottom:'4px'
  }
}));

const Search = ({
  service
}) => {
  const history = useHistory();
  const [state, boundActions] = useReviewSearch(service);

  const classes = useStyles();

  const selectedWorkflowChipData =
    state.selectedCriteria[CRITERIA_ITEM_TYPES.WORKFLOW_STEP]
    .reduce((acc, curr) => {
      const fullData = state.workflow.items.filter(x => x.value === curr)[0];
      return acc.concat(fullData);
    }, []);

  const selectedFinalizedByChipData =
    state.selectedCriteria[CRITERIA_ITEM_TYPES.FINALIZED_BY]
    .reduce((acc, curr) => {
      const fullData = state.finalizedBy.items.filter(x => x.value === curr)[0];
      return acc.concat(fullData);
    }, []);


  const selectedAuditedByChipData =
    state.selectedCriteria[CRITERIA_ITEM_TYPES.AUDITED_BY]
    .reduce((acc, curr) => {
      const fullData = state.auditedBy.items.filter(x => x.value === curr)[0];
      return acc.concat(fullData);
    }, []);

  const selectedOnHoldByChipData =
    state.selectedCriteria[CRITERIA_ITEM_TYPES.ONHOLD_BY]
    .reduce((acc, curr) => {
      const fullData = state.onHoldBy.items.filter(x => x.value == curr)[0];
      return acc.concat(fullData);
    }, []);

  return (
    <div className={classes.root}>
      <div>
        <h3>Review Search</h3>
      </div>

      {/* contract */}
      <div className={classes.leftcol}>
        <div className={classes.filteritem}>
          <div>Contract:</div>
          <select
            onChange={boundActions.setSelectedContract}
            value={state.contracts.selectedItem}
          >
            <option value="-1">All Contracts (MRN required)</option>
            {
              state.contracts.items.map(x => (
                <option
                  key={x.value}
                  value={x.value}
                >
                  {x.label}
                </option>
              ))
            }
          </select>
        </div>

        {/* facility */}
        <div className={classes.filteritem}>
          <div>Facility:</div>
          <select
            onChange={boundActions.setSelectedFacility}
            value={state.facilities.selectedItem}
          >
            <option value="-1">Any Facility</option>
            {
              state.facilities.items.map(x => (
                <option
                  key={x.value}
                  value={x.value}
                >
                  {x.label}
                </option>
              ))
            }
          </select>
        </div>

        {/* workflow */}
        <div>
          <div className={classes.dropdownwithchips}>
            <div>Workflow:</div>
            <select
              onChange={e => {
                const itemId = e.target.value;
                boundActions.selectCriteriaItem(
                  CRITERIA_ITEM_TYPES.WORKFLOW_STEP,
                  itemId
                );
              }}
              value={state.workflow.selectedItem} // should always be -1
            >
              <option value="-1">Choose a Workflow Step</option>
              {
                state.workflow.items.map(x => (
                  <option
                    key={x.value}
                    value={x.value}
                  >
                    {x.label}
                  </option>
                ))
              }
            </select>
          </div>

          <div className={classes.chipswithdropdown}>
            <div>Selected Workflow Steps: </div>
            {
              selectedWorkflowChipData.map(x => (
                <GeneralChip
                  key={x.value}
                  item={x}
                  isDelible={true}
                  onDelete={() => boundActions.removeCriteriaItem(
                    CRITERIA_ITEM_TYPES.WORKFLOW_STEP,
                    x.value
                  )}
                />
              ))
            }
          </div>
        </div>
        <div className={classes.filteritem}>
              <div>Hold Reason:</div>
              <select
                onChange={boundActions.setSelectedEncounterHoldOption}
                value={state.encounterHoldOptions.selectedItem}
              >
                {
                  state.encounterHoldOptions.items.map(x => (
                    <option
                      key={x.value}
                      value={x.value}
                    >
                      {x.label}
                    </option>
                  ))
                }
              </select>
          </div>
          <div className={classes.filteritem}>
              <div>Hold Status:</div>
              <select
                onChange={boundActions.setSelectedEncounterReviewStatusOption}
                value={state.encounterReviewStatusOptions.selectedItem}
              >
                {
                  state.encounterReviewStatusOptions.items.map(x => (
                    <option
                      key={x.value}
                      value={x.value}
                    >
                      {x.label}
                    </option>
                  ))
                }
              </select>
          </div>
        {/* onholdBy */}
        <div>
          <div className={classes.dropdownwithchips}>
            <div>On Hold User:</div>
              <select
                onChange={e => {
                  const itemId = e.target.value;
                  boundActions.selectCriteriaItem(
                    CRITERIA_ITEM_TYPES.ONHOLD_BY,
                    itemId
                  );
                }}
                value={state.onHoldBy.selectedItem} // should always be -1
              >
                <option value="-1">Choose On Hold By</option>
                {
                  state.onHoldBy.items.map(x => (
                    <option
                      key={x.value}
                      value={x.value}
                    >
                      {x.label}
                    </option>
                  ))
                }
              </select>
          </div>

          <div className={classes.chipswithdropdown}>
            <div>Selected On Hold By: </div>
            {
              selectedOnHoldByChipData.map(x => (
                <GeneralChip
                  key={x.value}
                  item={x}
                  isDelible={true}
                  onDelete={() => boundActions.removeCriteriaItem(
                    CRITERIA_ITEM_TYPES.ONHOLD_BY,
                    x.value
                  )}
                />
              ))
            }
          </div>
        </div>
        {/* finalizedBy */}
        <div>
          <div className={classes.dropdownwithchips}>
            <div>Finalize User:</div>
            <select
              onChange={e => {
                const itemId = e.target.value;
                boundActions.selectCriteriaItem(
                  CRITERIA_ITEM_TYPES.FINALIZED_BY,
                  itemId
                );
              }}
              value={state.finalizedBy.selectedItem} // should always be -1
            >
              <option value="-1">Choose Finalized By</option>
              {
                state.finalizedBy.items.map(x => (
                  <option
                    key={x.value}
                    value={x.value}
                  >
                    {x.label}
                  </option>
                ))
              }
            </select>
          </div>

          <div className={classes.chipswithdropdown}>
            <div>Selected Finalized By: </div>
            {
              selectedFinalizedByChipData.map(x => (
                <GeneralChip
                  key={x.value}
                  item={x}
                  isDelible={true}
                  onDelete={() => boundActions.removeCriteriaItem(
                    CRITERIA_ITEM_TYPES.FINALIZED_BY,
                    x.value
                  )}
                />
              ))
            }
          </div>
        </div>

        {/* audited by */}
        <div>
          <div className={classes.dropdownwithchips}>
            <div>Audit User:</div>
            <select
              onChange={e => {
                const itemId = e.target.value;
                boundActions.selectCriteriaItem(
                  CRITERIA_ITEM_TYPES.AUDITED_BY,
                  itemId
                );
              }}
              value={state.auditedBy.selectedItem} // should always be -1
            >
              <option value="-1">Choose Audited By</option>
              {
                state.auditedBy.items.map(x => (
                  <option
                    key={x.value}
                    value={x.value}
                  >
                    {x.label}
                  </option>
                ))
              }
            </select>
          </div>

          <div className={classes.chipswithdropdown}>
            <div>Selected Audited By: </div>
            {
              selectedAuditedByChipData.map(x => (
                <GeneralChip
                  key={x.value}
                  item={x}
                  isDelible={true}
                  onDelete={() => boundActions.removeCriteriaItem(
                    CRITERIA_ITEM_TYPES.AUDITED_BY,
                    x.value
                  )}
                />
              ))
            }
          </div>
        </div>

        {/* mrn */}
        <div>
          <div className={classes.filteritem}>
            <div>MRN:</div>
            <input
              name="mrn"
              type="text"
              value={state.inputs[INPUT_TYPES.TEXT].mrn}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.TEXT,
                  'mrn',
                  value
                );
              }}
            />
          </div>
        </div>

        {/* accountNumber */}
        <div>
          <div className={classes.filteritem}>
            <div>Account Number:</div>
            <input
              name="accountNumber"
              type="text"
              value={state.inputs[INPUT_TYPES.TEXT].accountNumber}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.TEXT,
                  'accountNumber',
                  value
                );
              }}
            />
          </div>
        </div>

        {/* start date end date DOS */}
        <div>
          <div className={classes.filteritem}>
            <div>Date of Service:</div>
            <input
              name="dosStart"
              type="date"
              value={state.inputs[INPUT_TYPES.DATE].dosStart}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.DATE,
                  'dosStart',
                  value
                );
              }}
            />&nbsp;To&nbsp;
            <input
              name="dosEnd"
              type="date"
              value={state.inputs[INPUT_TYPES.DATE].dosEnd}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.DATE,
                  'dosEnd',
                  value
                );
              }}
            />
          </div>
        </div>

        {/* start date end date finalized on */}
        <div>
          <div className={classes.filteritem}>
            <div>Finalized On:</div>
            <input
              name="finalizedOnStart"
              type="date"
              value={state.inputs[INPUT_TYPES.DATE].finalizedOnStart}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.DATE,
                  'finalizedOnStart',
                  value
                );
              }}
            />&nbsp;To&nbsp;
            <input
              name="finalizedOnEnd"
              type="date"
              value={state.inputs[INPUT_TYPES.DATE].finalizedOnEnd}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.DATE,
                  'finalizedOnEnd',
                  value
                );
              }}
            />
          </div>
        </div>

        {/* start date end date audited on */}
        <div>
          <div className={classes.filteritem}>
            <div>Audited On:</div>
            <input
              name="auditedOnStart"
              type="date"
              value={state.inputs[INPUT_TYPES.DATE].auditedOnStart}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.DATE,
                  'auditedOnStart',
                  value
                );
              }}
            />&nbsp;To&nbsp;
            <input
              name="auditedOnEnd"
              type="date"
              value={state.inputs[INPUT_TYPES.DATE].auditedOnEnd}
              onChange={e => {
                const value = e.target.value;
                boundActions.changeInputValue(
                  INPUT_TYPES.DATE,
                  'auditedOnEnd',
                  value
                );
              }}
            />
          </div>
        </div>
        {/* search button */}
        <div>
          <button
            onClick={() => {
              const dto = {
                selectedContractId: state.contracts.selectedItem,
                selectedFacilityId: state.facilities.selectedItem,
                mrn: state.inputs[INPUT_TYPES.TEXT].mrn,
                accountNumber: state.inputs[INPUT_TYPES.TEXT].accountNumber,
                patientName: '', // intentionally blank for now
                dosStart: state.inputs[INPUT_TYPES.DATE].dosStart,
                dosEnd: state.inputs[INPUT_TYPES.DATE].dosEnd,
                finalizedOnStart: state.inputs[INPUT_TYPES.DATE].finalizedOnStart,
                finalizedOnEnd: state.inputs[INPUT_TYPES.DATE].finalizedOnEnd,
                auditedOnStart: state.inputs[INPUT_TYPES.DATE].auditedOnStart,
                auditedOnEnd: state.inputs[INPUT_TYPES.DATE].auditedOnEnd,
                workflowStep:
                  state.selectedCriteria[CRITERIA_ITEM_TYPES.WORKFLOW_STEP],
                finalizedBy:
                  state.selectedCriteria[CRITERIA_ITEM_TYPES.FINALIZED_BY],
                auditedBy:
                  state.selectedCriteria[CRITERIA_ITEM_TYPES.AUDITED_BY],
                encounterHoldReasonId: state.encounterHoldOptions.selectedItem,
                encounterHoldStatusId: state.encounterReviewStatusOptions.selectedItem,
                onHoldBy: state.selectedCriteria[CRITERIA_ITEM_TYPES.ONHOLD_BY]
              };

              if (dto.selectedContractId <= 0 && (dto.mrn === '' || dto.mrn <= 0)) {
                alert('Must enter a MRN if no contract is selected.');
                return false;
              }

              boundActions.search(dto);
            }}
          >
            <span>Search</span>
          </button>
        </div>
      </div>
      <div className={classes.rightcol}>
        <SearchResults
          results={state.searchResults}
          boundActions={boundActions}
          history={history}
        />
      </div>

      <LoadingDialog
        isOpen={state.isLoading}
        loadingMessage={state.statusMessage}
      />
    </div>
  );
};

Search.propTypes = {
  service: PropTypes.shape({
    // TODO
  }).isRequired
};

export default Search;
